import React from 'react';
import { useNavigate, useLocation, useSearchParams } from 'react-router-dom';
import {
  Users, Lightning, ChartBar, Bug,
  ChatCircleText, CalendarBlank, PaperPlaneTilt,
} from '@phosphor-icons/react';

const TABS = [
  { id: 'dashboard', label: 'Dashboard', icon: ChartBar, to: '/admin' },
  { id: 'events', label: 'Events', icon: CalendarBlank, to: '/admin/events' },
  { id: 'players', label: 'Members', icon: Users, to: '/admin/members' },
  { id: 'challenges', label: 'Challenges', icon: Lightning, to: '/admin?tab=challenges' },
  { id: 'comms', label: 'Comms', icon: ChatCircleText, to: '/admin?tab=comms' },
  { id: 'communications', label: 'Bulk SMS', icon: PaperPlaneTilt, to: '/admin/communications' },
  { id: 'debug', label: 'Debug', icon: Bug, to: '/admin?tab=debug' },
];

// Map the current URL to the active admin section so the right pill is
// highlighted on every nested admin route (not just /admin).
export function activeAdminSection(pathname, tabParam) {
  if (pathname.startsWith('/admin/events')
      || pathname.startsWith('/admin/club-events')
      || pathname.startsWith('/admin/ladders')
      || pathname.startsWith('/tournaments/')
      || pathname.startsWith('/round-robins/')) return 'events';
  if (pathname.startsWith('/admin/members')) return 'players';
  if (pathname.startsWith('/admin/communications')) return 'communications';
  if (pathname === '/admin') return tabParam || 'dashboard';
  return tabParam || 'dashboard';
}

// Persistent Admin navigation. Rendered once by AppLayout on every admin
// route, so nested management/editor/creation pages all keep the nav.
export default function AdminNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const active = activeAdminSection(location.pathname, searchParams.get('tab'));

  return (
    <nav
      data-testid="admin-nav"
      aria-label="Admin sections"
      className="flex flex-wrap gap-1 bg-[#f0ece3] p-1 rounded-xl"
    >
      {TABS.map((t) => {
        const isActive = active === t.id;
        return (
          <button
            key={t.id}
            data-testid={`admin-tab-${t.id}`}
            aria-current={isActive ? 'page' : undefined}
            onClick={() => navigate(t.to)}
            className={`flex items-center justify-center gap-1.5 px-3 py-2 rounded-lg text-[11px] font-medium transition-all whitespace-nowrap ${
              isActive
                ? 'bg-[#fbfaf8] text-[#015e3f] shadow-sm'
                : 'text-[#6a766e] hover:text-[#013523]'
            }`}
          >
            <t.icon size={14} weight={isActive ? 'fill' : 'regular'} />
            {t.label}
          </button>
        );
      })}
    </nav>
  );
}
